/**
 * 응답에 더할 값을 계산한다. handler 는 db 의 원천을 고치고, 응답은 여기를 거쳐 만든다 —
 * 같은 값을 두 곳에 들고 있다가 어긋나지 않게.
 */
import type { Me, Staff } from "@/types";
import { db } from "./db";

/** 응답에 더하는 "나" — 메뉴는 role 과 is_hr 로 그린다. 관리자는 늘 HR 로 친다. */
export const toMe = (u: Staff): Me => ({
  id: u.id,
  email: u.email,
  name: u.name,
  role: u.role,
  standard_daily_hours: u.standard_daily_hours,
  is_hr: u.role === "admin" || u.is_hr,
  totp_enabled: u.totp_enabled,
  avatar_url: u.avatar_url,
});

/** 승인된 휴가로 그날 쉬는 시간 — 종일이면 기준 시간 전부, 시각 범위면 그 시간만. */
export function vacationHoursOn(userId: string, date: string): number {
  const vacation = db.vacations.find(
    (row) =>
      row.user_id === userId &&
      row.status === "approved" &&
      row.start_date <= date &&
      date <= row.end_date
  );
  if (!vacation) return 0;
  const standard = db.users.find((u) => u.id === userId)?.standard_daily_hours ?? 8;
  if (!vacation.start_time || !vacation.end_time) return standard;
  const minutes = (time: string) => Number(time.slice(0, 2)) * 60 + Number(time.slice(3, 5));
  return (minutes(vacation.end_time) - minutes(vacation.start_time)) / 60;
}
